import { render, staticRenderFns } from "./uyeYorumlar.vue?vue&type=template&id=13e5d5cb&scoped=true&"
import script from "./uyeYorumlar.vue?vue&type=script&lang=js&"
export * from "./uyeYorumlar.vue?vue&type=script&lang=js&"
import style0 from "./uyeYorumlar.vue?vue&type=style&index=0&id=13e5d5cb&lang=scss&scoped=true&"
import style1 from "./uyeYorumlar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e5d5cb",
  null
  
)

export default component.exports